module.exports = __webpack_public_path__ + "img/read-more-above.c27601e7.svg";